import { enumsTypes, enums } from "@shared/constants";
import { SITE_URL } from "@shared/env";
import { getQueryParameters } from "@shared/utils/urls/url-utils";
import { canAccessParentHref } from "@shared/utils/window/window-utils";

/**
 * Returns the purchase_source_platform to use for a widget basket,
 * respecting the query parameter purchase_source_platform.
 */
export const getEmbeddedPurchasePlatform = ():
  | enumsTypes.PurchaseSourcePlatformMapIdType
  | undefined => {
  if (typeof document !== "undefined" && typeof window !== "undefined") {
    // check query params for the purchase platform
    const parentUrl = canAccessParentHref()
      ? window?.top?.location?.href
      : document.referrer;

    const queryParams = getQueryParameters(parentUrl);
    const $purchaseSourcePlatform = queryParams.purchase_source_platform;

    const PSP = enums.PURCHASE_SOURCE_PLATFORM_MAP;

    // use the web platform (psp_web) as the default value
    let returnVal: enumsTypes.PurchaseSourcePlatformMapIdType =
      PSP.PLATFORM_WEB.id;

    if (window?.Cypress) {
      // exclude embedded status from Cypress test environment
      returnVal = PSP.PLATFORM_WEB.id;
    } else if (
      canAccessParentHref() &&
      window?.top?.location?.href?.includes(SITE_URL)
    ) {
      // if we're on the showpass site, use psp_web
      returnVal = PSP.PLATFORM_WEB.id;
    } else {
      // if we're not on the showpass site, use psp_widget
      returnVal = PSP.PLATFORM_WIDGET.id;

      // and respect a queryparam override
      if ($purchaseSourcePlatform) {
        returnVal = $purchaseSourcePlatform;
      }
    }
    return returnVal;
  }
  return undefined;
};
